module.exports = __webpack_public_path__ + "img/xshyjjj.caa3a681.jpg";